import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClienteBasicFrmAddComponent } from './cliente-basic-frm-add/cliente-basic-frm-add.component';
import { ClienteFrmAddComponent } from './cliente-frm-add/cliente-frm-add.component';
import { ProductoFrmAddComponent } from './producto-frm-add/producto-frm-add.component';
import { ProveedorFrmAddComponent } from './proveedor-frm-add/proveedor-frm-add.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { LoadingModule } from 'ngx-loading';
import { RlTagInputModule } from 'angular2-tag-input';
import { UiSwitchModule } from 'ngx-toggle-switch';
import { RouterModule } from '@angular/router';
import { TabsModule } from 'ngx-bootstrap';
import { ControlsModule } from '../controls/controls.module';
import { PipesModule } from '../pipes/pipes.module';
// import { DirectivesModule } from '../directives/directives.module';
import { TabOrderDirective } from './tab-order/tab-order.directive';
// import { TabOrderDirective } from '../config/tab-order.directive';


@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    LoadingModule.forRoot({
      backdropBorderRadius: '5px',
      fullScreenBackdrop: true
    }),
    RlTagInputModule,
    UiSwitchModule,
    RouterModule,
    TabsModule,
    ControlsModule,
    PipesModule,
    // DirectivesModule
  ],
  declarations: [
    ClienteBasicFrmAddComponent,
    ClienteFrmAddComponent,
    ProductoFrmAddComponent,
    ProveedorFrmAddComponent,
    TabOrderDirective,
  ],
  exports: [
    ClienteBasicFrmAddComponent,
    ClienteFrmAddComponent,
    ProductoFrmAddComponent,
    ProveedorFrmAddComponent
  ],
  entryComponents: [
    ClienteBasicFrmAddComponent,
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
})
export class CustomFormModule { }



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/forms/custom-form.module.ts